import { useState } from 'react'

export type Params = {
  debug?: boolean
  name?: string
}

const useShowMore = ({ debug = false, name = 'no name specified' }: Params = {}) => {
  const [isShowMore, setShowMore] = useState<boolean>(false)

  const showMore = () => {
    if (debug) {
      // eslint-disable-next-line no-console
      console.info('show more: ', name)
    }
    setShowMore(true)
  }

  const showLess = () => {
    if (debug) {
      // eslint-disable-next-line no-console
      console.info('show less: ', name)
    }
    setShowMore(false)
  }

  return { isShowMore, showMore, showLess }
}

export default useShowMore
